import '../vendor/slick';

export default class TimelineSlider {
  constructor() {
    this.$slider = $('.timeline');
  }

  sliderInit() {
    this.$slider.slick({
      arrows: true,
      variableWidth: true,
      slidesToShow: 10,
      // sliderToScroll: 1,
      // speed: 300,
    });
    const rightArrow =`<i class="icon-small_right_arrow_grey"></i>`;
    const leftArrow =`<i class="icon-small_left_arrow_grey"></i>`;
    $('.slick-next').html(rightArrow);
    $('.slick-prev').html(leftArrow);
  }


  init() {
    this.sliderInit();
  }
}
